import React from 'react';
import { Link } from 'react-router-dom'

// date stuff
import formatDate from 'date-fns/format';
import parseDate from 'date-fns/parse';
import isToday from 'date-fns/is_today';
import isSameDay from 'date-fns/is_same_day';
import startOfWeek from 'date-fns/start_of_week';
import lastDayOfWeek from 'date-fns/last_day_of_week';
import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';

import _ from 'underscore';
import { Donut } from 'rebass';
import pathOr from 'ramda/src/pathOr';
import path from 'ramda/src/path';
import formatNumber from 'comma-number';
import { Line } from 'react-chartjs-2';
import { DropdownButton, MenuItem } from 'react-bootstrap';

import Loader from '../../../common/components/notifications/Loader';
import DateFilters from '../../../events/components/DateFilters';
import events from './manifest';
import AssetsTable from './AssetsTable';
var DATE_FORMAT = 'YYYY-MM-DD';

var formatDatePretty = _.partial(formatDate, _, 'MMM D, YYYY');
var toDateFormat = _.compose(
    _.partial(formatDate, _, 'ddd, MM-DD-YYYY'),
    function (string) {
        return new Date(string);
    }
);

function toNumber (n) {
    return parseInt(n || 0, 10);
}

function total (prop, list) {
    return _(list).map(function (xs, date) {
        return xs.reduce(function (acc, x) {
            return acc + toNumber(x[prop]);
        }, 0);
    });
}

function noRecords (props) {
    return props.analytics.data.meta === '0 records found';
}

/*
{
  "ads": {
    "2017-03-25 00:00:00": [
      {
        "clientID": "9375922947",
        "actionDate": "2017-03-25 00:00:00",
        "campaignID": "37",
        "assetID": "fe90f848e05b73c458f271de89b814e8dab469c3",
        "counts": "1",
        "clickCount": "1",
        "weight": "1"
      }
    ]
  },
  "assetTotalCounts": {
    "fe90f848e05b73c458f271de89b814e8dab469c3": 1,
    "c45ac6da57612c8429a67e3dc9c5f601e69ab9ac": 120
  },
  "assetTotalClicks": {
    "fe90f848e05b73c458f271de89b814e8dab469c3": 1,
    "c45ac6da57612c8429a67e3dc9c5f601e69ab9ac": 4,
  },
  "resultsTotalCounts": 1765,
  "resultsTotalClicks": 35,
  "campaignTotalCounts": 87966,
  "campaignTotalClicks": 2214
}
*/

function chartPlays (ads) {
    return {
        labels: Object.keys(ads).map(toDateFormat),
        datasets: [
            {
                label: 'Plays',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: total('counts', ads)
            }
        ]
    };
}

function chartClicks (ads) {
    return {
        labels: Object.keys(ads).map(toDateFormat),
        datasets: [
            {
                label: 'Clicks',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: total('clickCount', ads)
            }
        ]
    };
}


function VastAnalyticsView (props) {
    if (props.resolving > 0) return <Loader message="Loading" />;

    var data = props.analytics.data;
    var clicks = pathOr(0, ['analytics', 'data', 'resultsTotalClicks'], props);
    var plays = pathOr(0, ['analytics', 'data', 'resultsTotalCounts'], props);

    var currentStartDate = path(
        ['analytics', 'data', 'meta', 'resultsStartDate'],
        props
    );

    var currentEndDate = path(
        ['analytics', 'data', 'meta', 'resultsStartEnd'],
        props
    );

    var errors = props.analytics.errors.concat(props.vast.errors);
    if (!props.vast.data) {
        errors = [{message:"Missing campaign data"}]
        // vv automatically redirect to /ads vv
        // return <meta http-equiv="Refresh" content="0; url=/admin/manage/ads"/>
    }
    if (errors.length) {
        return <div className="vast-analytics-view container-fluid">
            <div className="row">
                {errors.map(function (err, i) {
                    return <p key={i} className="bg-danger"
                        style={{ padding: '2em' }}
                    >
                        ERROR: {err.message}
                    </p>;
                })}
            </div>
        </div>;
    }

    return <div className="vast-analytics-view container-fluid">
        <div className="callout row">

            <h1 className="h4">
                <Link to={'/manage/ads/edit?id=' +
                    props.vast.data.campaignID}
                >
                    {props.vast.data.name}
                </Link>
            </h1>

            <p>
                {props.vast.data.description} | <strong>Start date:</strong> {formatDate(
                    new Date(props.vast.data.startDate),
                    'MM-DD-YYYY'
                )} | <strong>End date:</strong> {props.vast.data.endDate ?
                    formatDate(props.vast.data.endDate, 'MM-DD-YYYY') :
                    'none'
                } | <strong>Position: </strong>{props.vast.data.actions.name} | <strong>Scope: </strong>
                {props.vast.data.type.typeDesc}
            </p>
        </div>

        <StatsQuery {...props} />

        <YourBasicStats
            currentStartDate={currentStartDate}
            currentEndDate={currentEndDate}
            clicks={clicks}
            plays={plays}
        />

        <AssetsTable {...props} />

        {data && data.ads ? [
            <div className="callout row" key={0}>
                <div className="col-sm-12">
                    <Line height={300} data={chartClicks(data.ads)} />
                </div>
            </div>,

            <div className="callout row" key={1}>
                <div className="col-sm-12">
                    <Line height={300} data={chartPlays(data.ads)} />
                </div>
            </div>] :

            null
        }
    </div>;
}

VastAnalyticsView.defaultProps = {
    resolving: 0,
    vast: {},
    analytics: {}
};

// VastAnalyticsView.propTypes = {
//     resolving: pt.number.isRequired,
//     vast: pt.object.isRequired,
//     analytics: pt.object.isRequired
// };


// children -----------------------------

function YourBasicStats (props) {
    var plays = props.plays;
    var clicks = props.clicks;

    function dates (props) {
        if (!props.currentStartDate) return null;
        return formatDatePretty(parseDate(props.currentStartDate)) +
            ' – ' +
            formatDatePretty(parseDate(props.currentEndDate))
        ;
    }

    return <div className="callout row">
        <div className="col-sm-12">
            <small>
                {dates(props)}
            </small>
        </div>

        <div className="col-sm-4 text-center vast-stat">
            <Stat label={plays == 1 ? 'Play' : 'Plays'} value={formatNumber(plays)} />
        </div>

        <div className="col-sm-4 text-center vast-stat">
            <Stat
                style={{ verticalAlign: 'middle' }}
                label={clicks == 1 ? 'Click' : 'Clicks'}
                value={formatNumber(clicks)}
            />
        </div>

        <div className="col-sm-4 text-center vast-stat vast-click-rate">
            <Donut
                color="primary"
                size={80}
                strokeWidth={8}
                value={(clicks / plays) || 0}
            />
            <span style={{
                marginTop: '1em',
                display: 'block',
                fontWeight: '600'
            }}>
                Click rate
            </span>
        </div>
    </div>;
}

function StatsQuery (props) {
    if (noRecords(props)) return null;

    var today = isToday(parseDate(props.analytics.data.meta.resultsStartDate));
    var thisWeek = isSameDay(
        parseDate(props.analytics.data.meta.resultsStartDate),
        startOfWeek(new Date())
    ) && isSameDay(
        parseDate(props.analytics.data.meta.resultsStartEnd),
        lastDayOfWeek(new Date())
    );

    var thisMonth = isSameDay(
        parseDate(props.analytics.data.meta.resultsStartDate),
        startOfMonth(new Date())
    ) && isSameDay(
        parseDate(props.analytics.data.meta.resultsStartEnd),
        endOfMonth(new Date())
    );

    var forever = isSameDay(
        parseDate(props.analytics.data.meta.resultsStartDate),
        parseDate(props.vast.data.startDate)
    ) && isSameDay(
        parseDate(props.analytics.data.meta.resultsStartEnd),
        props.vast.data.endDate ?
            parseDate(props.vast.data.endDate) :
            new Date()
    );

    return <div className="row">
        <div className="col-sm-8">

            <DateFilters
                filters={{
                    startDateTime: props.query.startDate,
                    stopDateTime: props.query.endDate
                }}
                onChange={_.compose(
                    props.push,
                    events.setQuery,
                    function (dates) {
                        return dates.startDateTime ? {
                            startDate: dates.startDateTime
                                .format(DATE_FORMAT)
                        } : {
                            endDate: dates.stopDateTime
                                .format(DATE_FORMAT)
                        };
                    }
                )}
            />
        </div>

        <div className="col-sm-2">
            <DropdownButton
                title={today ?
                    'Today' :
                    thisWeek ?
                    'This week' :
                    thisMonth ?
                    'This month' :
                    forever ?
                    'Forever' :
                    'Quick filter'
                }

                id="date-quick-filter"
                onSelect={_.compose(
                    props.push,
                    events.quickFilter
                )}
            >

                <MenuItem active={today} eventKey="today">Today</MenuItem>
                <MenuItem active={thisWeek} eventKey="thisWeek">
                    This week
                </MenuItem>
                <MenuItem active={thisMonth} eventKey="thisMonth">
                    This month
                </MenuItem>
                <MenuItem active={forever} eventKey="forever">
                    Forever
                </MenuItem>

            </DropdownButton>
        </div>

        <div className="col-sm-2 pull-right text-right">
            <button className="btn btn-default"
                type="submit"
                onClick={function (ev) {
                    ev.preventDefault();
                    props.push(events.submitQuery());
                }}

                disabled={(props.query.startDate ===
                    props.analytics.data.meta.resultsStartDate) &&
                    (props.query.endDate ===
                        props.analytics.data.meta.resultsStartEnd)
                }
            >
                Submit
            </button>
        </div>

    </div>;
}

export default VastAnalyticsView;

function Stat (props) {
    return (<div style={props.style}>
        <div style={{ fontSize: "6rem", fontWeight: 'bold'}}>
            {props.value}
        </div>
        <strong>
            {props.label}
        </strong>
    </div>);
}
